import React, { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { languagesService } from '../services/languages.service';
import { languagesKeys } from '../hooks/use-languages-query';

export const LanguagePrefetch: React.FC = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    // Only prefetch if data is not already in cache
    const cachedData = queryClient.getQueryData(languagesKeys.all);
    
    if (!cachedData) {
      console.log('🌍 Prefetching languages (no cache found)');
      queryClient.prefetchQuery({
        queryKey: languagesKeys.all,
        queryFn: () => languagesService.getAll(),
        staleTime: 1000 * 60 * 60 * 24, // 24 hours
      });
    } else {
      console.log('✅ Languages already cached, skipping prefetch');
    }
  }, [queryClient]);

  return null;
};
